import { useEditorActions } from '../../hooks/useEditorActions';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useFieldOptions } from '../../hooks/useFieldOptions';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import EditorFieldOption from './EditorFieldOption';
import EditorOptionsGroupHeading from './EditorOptionsGroupHeading';
import EditorNoResultsMessage from './EditorNoResultsMessage';
import EditorFieldLoadMoreOption from './EditorFieldLoadMoreOption';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import EditorScrollingBodyContainer from './EditorScrollingBodyContainer';
import styled from 'foundations-theming/utils';
import { View } from 'foundations-components/components/View';
import { PropertySearchSuggestions } from './NLPSuggestions/PropertySearchSuggestions';
import { recordPropertyClickedEvent } from './NLPSuggestions/recordPropertyClickedEvent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OptionsHeading = styled(EditorOptionsGroupHeading)(({
  theme
}) => ({
  fontSize: theme.typography['heading-100'].fontSize
}));
const EditorConditionFieldOptions = props => {
  const {
    filterFamily,
    hiddenProperties,
    isLoadingFields,
    onSelectField,
    searchString
  } = props;
  const {
    isLoadingFields: isLoadingFieldsInitial,
    props: {
      useOnePanel,
      enableNLPPropertySearchForReporting
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const [loadingMore, setLoadingMore] = useState(false);
  const {
    selectField
  } = useEditorActions();
  const {
    options: fieldOptions
  } = useFieldOptions(filterFamily, searchString, hiddenProperties);
  const suggestedPropertiesResultsRef = useRef();
  const prevOptionsLength = useRef(fieldOptions.length);
  useEffect(() => {
    if (prevOptionsLength.current < fieldOptions.length && loadingMore) {
      setLoadingMore(false);
    }
    prevOptionsLength.current = fieldOptions.length;
  }, [fieldOptions.length, loadingMore]);
  const handleOnSelectField = useCallback((field, usedSemanticSearch = false) => {
    if (onSelectField) {
      onSelectField === null || onSelectField === void 0 || onSelectField(filterFamily, field);
    } else {
      var _suggestedPropertiesR;
      if (enableNLPPropertySearchForReporting) {
        recordPropertyClickedEvent({
          searchString,
          filterFamily,
          options: suggestedPropertiesResultsRef.current,
          selectedOption: field
        });
      }
      selectField(filterFamily, field, usedSemanticSearch, !!((_suggestedPropertiesR = suggestedPropertiesResultsRef.current) !== null && _suggestedPropertiesR !== void 0 && _suggestedPropertiesR.length));
    }
  }, [onSelectField, searchString, selectField, filterFamily, suggestedPropertiesResultsRef, enableNLPPropertySearchForReporting]);
  if (useOnePanel && isLoadingFieldsInitial || isLoadingFields) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.fieldSelectFlow.loadingFields"
      }),
      showLabel: true,
      size: "small"
    });
  }
  const hasNoOptions = fieldOptions.length === 0;
  return /*#__PURE__*/_jsxs(EditorScrollingBodyContainer, {
    children: [enableNLPPropertySearchForReporting && searchString && /*#__PURE__*/_jsx(PropertySearchSuggestions, {
      filterFamily: filterFamily,
      searchString: searchString,
      hiddenProperties: hiddenProperties,
      onSelectField: handleOnSelectField,
      suggestedPropertiesResultsRef: suggestedPropertiesResultsRef
    }), !enableNLPPropertySearchForReporting && hasNoOptions && /*#__PURE__*/_jsx(View, {
      padding: "400",
      margin: "auto",
      as: "div",
      children: /*#__PURE__*/_jsx(EditorNoResultsMessage, {
        message: "newCustomerDataFilters.fieldSelectFlow.noFiltersFoundMessage"
      })
    }), !hasNoOptions && fieldOptions.map((entry, index) => {
      const spaceStyleProps = index > 0 ? {
        marginBlockStart: '300'
      } : {};
      if (entry.get('heading')) {
        return /*#__PURE__*/_jsx(OptionsHeading, {
          spaceStyleProps: spaceStyleProps,
          children: /*#__PURE__*/_jsx(TruncateString, {
            children: entry.get('displayName')
          })
        }, `${index}-${entry.get('heading')}`);
      }
      if (entry.get('properties')) {
        return /*#__PURE__*/_jsx(EditorOptionsGroupHeading, {
          spaceStyleProps: spaceStyleProps,
          children: /*#__PURE__*/_jsx(TruncateString, {
            children: entry.get('displayName')
          })
        }, `${index}-${entry.get('name')}`);
      }
      return /*#__PURE__*/_jsx(EditorFieldOption, {
        field: entry,
        filterFamily: filterFamily,
        onClick: () => handleOnSelectField(entry)
      }, `${index}-${entry.get('name')}`);
    }), /*#__PURE__*/_jsx(EditorFieldLoadMoreOption, {
      filterFamily: filterFamily,
      isLoadingMore: loadingMore,
      onLoadMore: setLoadingMore,
      searchString: searchString
    })]
  });
};
export default EditorConditionFieldOptions;